<template>
  <div>
    <b-modal
      v-model="modalShow"
      centered
      ok-only
      centered
      class="text-center text-info"
    >
      Please Select Category and City
    </b-modal>
    <b-modal
      v-model="modalShow0"
      ok-only
      centered
      class="text-center text-info"
    >
      You are not logged in as a user or your email is not verified!
    </b-modal>
    <b-modal
      v-model="modalShow1"
      ok-only
      centered
      class="text-center text-info"
    >
      You can't add more shops to My SHOPiN!
    </b-modal>
    <b-modal
      v-model="modalShow2"
      ok-only
      centered
      class="text-center text-info"
    >
      Shop is added to My SHOPiN.
    </b-modal>
    <div class="loading" v-if="loading">
      <div class="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div id="admin-preloader" class="anim" v-if="loading1 == false">
      <div class="spinner">
        <div class="dot1"></div>
        <div class="dot2"></div>
      </div>
    </div>
    <div v-if="fetch">
      <section>
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark m-nav">
          <router-link class="navbar-brand" to="/">
            <img src="../../static/img/eshops-round.png" alt="eshops-logo" />
          </router-link>
          <button
            class="navbar-toggler float-right"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item mt-2">
                <router-link
                  :to="{ name: 'home' }"
                  class="m-link nav-link text-white"
                  >Home</router-link
                >
              </li>
              <!-- <li class="nav-item">
         <router-link :to="{name: 'regshop', params:{plan: 'Premium'}}" class="m-link nav-link text-white">Create Store</router-link>
      </li> -->
              <li class="nav-item">
                <router-link
                  v-if="admin"
                  :to="{ name: 'admin' }"
                  class="m-link nav-link text-white"
                  >Admin</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  v-if="pageadmin"
                  :to="{ name: 'admin-services' }"
                  class="m-link nav-link text-white"
                  >Admin</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  v-if="visitor"
                  :to="{ name: 'signin' }"
                  class="m-link nav-link text-white"
                  >Sign in</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  v-if="visitor"
                  :to="{ name: 'usersignup' }"
                  class="m-link nav-link text-white"
                  >Sign up</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  v-if="user"
                  :to="{ name: 'myaccount' }"
                  class="m-link nav-link text-white"
                  >My Account</router-link
                >
              </li>
              <li class="nav-item">
                <a
                  style="cursor: pointer"
                  @click="logout()"
                  v-if="user || admin || pageadmin"
                  class="m-link nav-link text-white"
                  >Sign out</a
                >
              </li>
            </ul>
          </div>
        </nav>

        <!-- Just an image -->
        <nav class="navbar navbar-dark bg-dark d-nav">
          <router-link class="navbar-brand" to="/">
            <img src="../../static/img/eshops-round.png" alt="eshops-logo" />
          </router-link>
          <div>
            <router-link :to="{ name: 'home' }" class="text-white mr-5">
              Home
            </router-link>
            <!-- <router-link :to="{name: 'regshop', params:{plan: 'Premium'}}" class="text-white mr-5"> Create Store</router-link> -->
            <router-link
              v-if="admin"
              :to="{ name: 'admin' }"
              class="m-link text-white mr-5"
              >Admin</router-link
            >
            <router-link
              v-if="pageadmin"
              :to="{ name: 'admin-services' }"
              class="m-link text-white mr-5"
              >Admin</router-link
            >
            <router-link
              v-if="visitor"
              :to="{ name: 'signin' }"
              class="m-link text-white mr-5"
              >Sign in</router-link
            >
            <router-link
              v-if="visitor"
              :to="{ name: 'usersignup' }"
              class="m-link text-white mr-5"
              >Sign up</router-link
            >
            <router-link
              v-if="user"
              :to="{ name: 'myaccount' }"
              class="m-link text-white mr-5"
              >My Account</router-link
            >
            <a
              style="cursor: pointer"
              @click="logout()"
              v-if="user || admin || pageadmin"
              class="text-white mr-5"
              >Sign out</a
            >
          </div>
        </nav>
        <div class="outer-menu d-nav">
          <input class="checkbox-toggle" type="checkbox" />
          <div class="hamburger">
            <div></div>
          </div>
          <div class="menu">
            <div>
              <div>
                <ul>
                  <li>
                    <router-link :to="{ name: 'home' }" class="text-white">
                      Home
                    </router-link>
                  </li>
                  <!-- <li><router-link :to="{name: 'regshop', params:{plan: 'Premium'}}" class="text-white"> Create Store</router-link></li> -->
                  <li>
                    <router-link
                      v-if="admin"
                      :to="{ name: 'admin' }"
                      class="text-white"
                    >
                      Admin</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      v-if="pageadmin"
                      :to="{ name: 'admin-services' }"
                      class="text-white"
                    >
                      Admin</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      v-if="visitor"
                      :to="{ name: 'signin' }"
                      class="text-white"
                    >
                      Sign in</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      v-if="visitor"
                      :to="{ name: 'usersignup' }"
                      class="text-white"
                    >
                      Sign up</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      v-if="user"
                      :to="{ name: 'myaccount' }"
                      class="text-white"
                    >
                      My Account</router-link
                    >
                  </li>
                  <li>
                    <a
                      style="cursor: pointer"
                      @click="logout()"
                      v-if="user || admin || pageadmin"
                      class="text-white"
                    >
                      Sign out</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- <section class="">
	<div class="container  col-lg-6 mt-3" style=" "  >
		
			<div  > 
<div id="carouselExampleControls" class="carousel slide " data-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img class="d-block w-100" src="../assets/main/images/b2.png" alt="First slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="../assets/main/images/b3.png" alt="Second slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="../assets/main/images/b1.png" alt="Third slide">
    </div>
  </div>
  <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
</div>
		
	</div>
</section> -->

      <!-- <section class="">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				
				<div class="advance-search">
					<form>
						
					</form>
				</div>
			</div>
		</div>
	</div>
</section>
<ul>
  <li ></li>
</ul> -->
      <section class="section-sm" style="padding-top: 0px">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="search-result bg-gray text-center">
                <h2
                  class="mb-0 m-size text-info"
                  v-if="
                    this.$route.query.loc != undefined &&
                    this.$route.query.cat != undefined
                  "
                >
                  Results for "{{ this.$route.query.cat }}" Shops in
                  {{ this.$route.query.loc }}
                </h2>
                <h2
                  class="text-danger mb-0 m-size"
                  v-if="
                    this.$route.query.loc == undefined &&
                    this.$route.query.cat == undefined &&
                    this.$route.fullPath == '/search'
                  "
                >
                  Please Select the Category & City
                </h2>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="category-search-filter">
                <div class="row">
                  <div class="col-12 form-row m-auto">
                    <el-form
                      :inline="true"
                      status-icon
                      label-width="120px"
                      :label-position="labelPosition"
                      size="medium"
                      class="m-auto el-form"
                    >
                      <el-cascader
                        clearable
                        class="form-item form-item2"
                        placeholder="Store category"
                        size="medium"
                        @change="selectCat"
                        v-model="cat"
                        :options="categories"
                        :show-all-levels="false"
                      ></el-cascader>

                      <el-cascader
                        clearable
                        class="form-item form-item2"
                        placeholder="City"
                        size="medium"
                        @change="handleChange"
                        v-model="city"
                        :options="cities"
                        :show-all-levels="false"
                      ></el-cascader>

                      <!-- <el-form-item  prop="category" style="width:200px; margin-right:0px;">
                  <el-select v-model="category" placeholder="Store category" >
                    <el-option label="Fashion" value="Fashion"></el-option>
                    <el-option label="Gems" value="Gems"></el-option>
                  </el-select>
              </el-form-item>
               <el-form-item  prop="location" class="form-item">
                <el-autocomplete 
                  class="inline-input"
                  v-model="location"
                  :fetch-suggestions="querySearch"
                  placeholder="Type the city"
                  @select="handleSelect">
                  </el-autocomplete>
              </el-form-item> -->
                      <el-form-item class="form-item form-item1">
                        <el-button
                          type="primary"
                          class="form-item form-item3"
                          @click="showme()"
                          >Search</el-button
                        >
                      </el-form-item>
                    </el-form>
                    <!-- <div class="form-group">
								
							     <a class='button pri text-light' @click="setRoute()">Search</a>
							</div> -->
                  </div>
                  <!-- <div class="col-md-4 text-right">
						
                <el-form  :inline="true"  status-icon label-width="50px" :label-position="labelPosition" size="mini">
                  	<span class="mr-2">sort</span>
						 <el-form-item  prop="sortby" style="width: 150px;">
                  <el-select v-model="sortby" placeholder="Sort By">
                    <el-option label="Zone one" value="shanghai"></el-option>
                    <el-option label="Zone two" value="beijing"></el-option>
                  </el-select>
              </el-form-item>
                </el-form>
						</div> -->
                </div>
              </div>
              <div class="product-grid-list">
                <div class="row mt-30 justify-content-around">
                  <div
                    v-if="noresults"
                    class="mt-3 mb-2 text-center text-danger h4"
                  >
                    No {{ this.$route.query.cat }} Shops in
                    {{ this.$route.query.loc }}
                  </div>
                  <template v-for="(shop, i) in shops">
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-4"
                      v-bind:key="shop.id"
                    >
                      <!-- product card -->
                      <div class="product-item bg-light">
                        <div class="card">
                          <!--      
		<div class="thumb-content" style="-webkit-clip-path: polygon(0 0, 100% 0, 100% 89%, 0% 100%);
clip-path: polygon(0 0, 100% 0, 100% 89%, 0% 100%); height:250px;">
		
			<a href="">
				<img class="card-img-top img-fluid" src="../../static/images/product-detail-01.jpg" alt="Shop image cap">
			</a>
		</div> -->
                          <div class="block2-pic hov-img0">
                            <router-link
                              v-if="
                                shop.isHosted != true && shop.isCloned != true
                              "
                              :to="{
                                name: 'storehome',
                                params: { storename: shop.owner },
                              }"
                              ><img
                                @click="userVisits(i)"
                                :src="shop.homeimg"
                                alt=""
                                width="100%"
                                height="200px"
                            /></router-link>
                            <router-link
                              v-if="shop.isCloned == true"
                              :to="{
                                name: 'storehome',
                                params: { storename: shop.realOwner },
                              }"
                              ><img
                                @click="userVisits(i)"
                                :src="shop.homeimg"
                                alt=""
                            /></router-link>
                            <a
                              v-if="shop.isHosted == true"
                              target="blank"
                              :href="shop.domain"
                              ><img
                                @click="userVisits(i)"
                                :src="shop.homeimg"
                                alt=""
                            /></a>
                            <!-- <el-checkbox v-model="checked"  style="visibility: hidden;" 	@change="submit(checked)"> 
										<i class="fa fa-heart" style="visibility: visible;"></i>
									</el-checkbox> -->
                            <!-- <i class="fa fa-heart fa-lg text-info" v-b-tooltip.hover title="Add to Wishlist"></i> -->

                            <!-- <a href="#" class="block2-btn flex-c-m stext-103 cl2 size-102 bg0 bor2 hov-btn1 p-lr-15 trans-04 js-show-modal1">
								Quick View
							</a> -->
                          </div>
                          <div class="card-body">
                            <span
                              class="float-right mr-3 tooltip100"
                              v-if="!shop.isfavshop"
                              data-tooltip="Add to My SHOPiN"
                            >
                              <i
                                class="fa fa-heart-o"
                                @click="addToFavourite(shop)"
                                style="cursor: pointer; font-size: 22px"
                              ></i
                            ></span>
                            <span
                              class="float-right mr-3 tooltip100"
                              v-if="shop.isfavshop"
                              data-tooltip="Added to My SHOPiN"
                            >
                              <i
                                class="fa fa-heart-o"
                                style="
                                  cursor: default;
                                  font-size: 22px;
                                  color: red;
                                "
                              ></i
                            ></span>

                            <span
                              class="card-title"
                              v-if="
                                shop.isHosted != true && shop.isCloned != true
                              "
                              @click="userVisits(i)"
                              ><router-link
                                :to="{
                                  name: 'storehome',
                                  params: { storename: shop.owner },
                                }"
                                class="text-primary"
                                >{{ shop.name }}</router-link
                              ></span
                            >
                            <span
                              class="card-title"
                              v-if="shop.isCloned == true"
                              @click="userVisits(i)"
                              ><router-link
                                :to="{
                                  name: 'storehome',
                                  params: { storename: shop.realOwner },
                                }"
                                class="text-primary"
                                >{{ shop.name }}</router-link
                              ></span
                            >
                            <span
                              class="card-title"
                              v-if="shop.isHosted == true"
                              @click="userVisits(i)"
                              ><a
                                :href="shop.domain"
                                target="blank"
                                class="text-primary"
                                >{{ shop.name }}</a
                              ></span
                            >

                            <!-- <ul class="list-inline product-meta mb-1 mt-2" v-if="shop.plan == 'Premium' || shop.plan == 'Enterprise'">
            <li class="list-inline-item mr-2">
		    		<a class="" style="color:red;"><i class="fa fa-home" aria-hidden="true"></i>Home Deliver</a>
		    	</li>
		    </ul> -->

                            <ul
                              class="list-inline product-meta mb-1"
                              v-if="shop.shoptype != ''"
                            >
                              <li class="list-inline-item">
                                <a class=""
                                  ><i class="fa fa-tag" aria-hidden="true"></i
                                  >{{ shop.shoptype }}</a
                                >
                              </li>
                            </ul>
                            <ul class="list-inline product-meta mb-1">
                              <li class="list-inline-item">
                                <a
                                  ><i
                                    class="fa fa-map-marker"
                                    aria-hidden="true"
                                  ></i
                                  >City : {{ shop.location }}</a
                                >
                              </li>
                            </ul>
                            <!-- <ul class="list-inline product-meta mb-1">
		    	<li class="list-inline-item">
		    		<a><i  class="fa fa-eye  " aria-hidden="true"></i>Views {{shop.visits}}</a>
		    	</li>
		    </ul> -->
                            <ul
                              class="list-inline product-meta mb-1"
                              v-if="shop.details.tel1"
                            >
                              <li class="list-inline-item">
                                <a :href="`tel:${shop.details.tel1}`"
                                  ><i
                                    class="fa fa-phone-square"
                                    aria-hidden="true"
                                  ></i
                                  >+94 {{ shop.details.tel1 }}</a
                                >
                              </li>
                            </ul>
                            <ul
                              class="list-inline product-meta mb-1"
                              v-if="!shop.details.tel1"
                            >
                              <li class="list-inline-item">
                                <a :href="`tel:${shop.regtel}`"
                                  ><i
                                    class="fa fa-phone-square"
                                    aria-hidden="true"
                                  ></i
                                  >+94 {{ shop.regtel }}</a
                                >
                              </li>
                            </ul>
                            <ul
                              class="list-inline product-meta mb-1"
                              v-if="shop.details.etime && shop.details.stime"
                            >
                              <li class="list-inline-item mr-2">
                                <a class=""
                                  ><i
                                    class="fa fa-clock-o"
                                    aria-hidden="true"
                                  ></i
                                  >Open - Close : {{ shop.details.stime }}AM -
                                  {{ shop.details.etime }}PM
                                </a>
                              </li>
                            </ul>

                            <ul
                              class="list-inline product-meta mb-2"
                              v-if="shop.details.address"
                            >
                              <li class="list-inline-item">
                                <a
                                  ><i
                                    class="fa fa-address-card"
                                    aria-hidden="true"
                                  ></i
                                  >{{ shop.details.address }}</a
                                >
                              </li>
                            </ul>
                            <a
                              v-if="shop.details.lat && shop.details.lng"
                              :href="`https://maps.google.com/?q=${shop.details.lat}, ${shop.details.lng}`"
                              target="_blank"
                              rel="noopener noreferrer"
                              ><el-button
                                size="mini"
                                type="primary"
                                class="my-2"
                                >Get Direction</el-button
                              ></a
                            >
                            <!-- <div class="product-ratings">
		    	<ul class="list-inline">
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item"><i class="fa fa-star"></i></li>
		    	</ul>
		    </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- <div class="col-sm-12 col-lg-3 col-md-3">
						
<div class="product-item bg-light">
	<div class="card">
		<div class="thumb-content" style="-webkit-clip-path: polygon(0 0, 100% 0, 100% 89%, 0% 100%);
clip-path: polygon(0 0, 100% 0, 100% 89%, 0% 100%); background-color: #fff; height: 200px;">
		
			<a href="">
				<img class="card-img-top img-fluid" src="images/products/sunset3.jpg" alt="">
			</a>
		</div>
		<div class="card-body">
		    <h4 class="card-title "><a href="" class="text-dark">Study Table Combo</a></h4>
		    <ul class="list-inline product-meta">
		    	<li class="list-inline-item">
		    		<a ><i class="fa fa-folder-open-o"></i>Furnitures</a>
		    	</li>
		    	<li class="list-inline-item">
		    		<a ><i class="fa fa-calendar"></i>26th December</a>
		    	</li>
		    </ul>
		    
		    <div class="product-ratings">
		    	<ul class="list-inline">
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item selected"><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item "><i class="fa fa-star"></i></li>
		    		<li class="list-inline-item ml-1"><span>Delete from favourite</span><i class="fa fa-trash ml-2 text-danger"></i></li>
		    	</ul>
		    </div>
		</div>
	</div>
</div>
		</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="flex-c-m flex-w w-full pb-5">
        <button
          @click="moreItems()"
          v-if="moreshops != undefined"
          class="flex-c-m stext-101 cl5 size-103 bg2 bor1"
        >
          More Shops
        </button>
      </div>
      <!--============================
=            Footer            =
=============================-->

      <footer class="footer section section-sm">
        <!-- Container Start -->
        <div class="container">
          <div class="row justify-content-around">
            <!-- <div class="col-lg-3 col-md-7 offset-md-1 offset-lg-0">
        
        <div class="block about">
         
          <img src="images/logo-footer.png" alt="">
          
          <p class="alt-color text-secondary">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
        </div>
         <ul class="social-media-icons mb-3">
              <li><a class="fa fa-facebook" href=""></a></li>
              <li><a class="fa fa-twitter" href=""></a></li>
              <li><a class="fa fa-pinterest-p" href=""></a></li>
              <li><a class="fa fa-vimeo" href=""></a></li>
            </ul>
      </div> -->
            <!-- Link list -->
            <div class="col-sm-6 col-lg-3">
              <div class="block block-link">
                <h4>Site Pages</h4>
                <ul>
                  <li class="px-0">
                    <router-link :to="{ name: 'home' }">Home</router-link>
                  </li>
                  <!-- <li><router-link :to="{name: 'regshop', params:{plan: 'Premium'}}">Create Store</router-link></li> -->
                  <li>
                    <router-link :to="{ name: 'about' }">About Us</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'termsofuse' }"
                      >Terms of Use</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'privacypolicy' }"
                      >Privacy Policy</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
            <!-- Link list -->
            <div class="col-sm-6 col-lg-4">
              <div class="block block-info">
                <h4>Contact Us</h4>
                <ul>
                  <li>
                    <a
                      ><i class="fa fa-phone mr-2" aria-hidden="true"></i>0719
                      500 600</a
                    >
                  </li>
                  <!-- <li>
                    <a
                      ><i class="fa fa-phone mr-2" aria-hidden="true"></i
                      >0113-601-444</a
                    >
                  </li> -->
                  <li>
                    <a
                      ><i class="fa fa-envelope mr-2" aria-hidden="true"></i
                      >info@eshops.lk</a
                    >
                  </li>
                </ul>
                <ul class="social-media-icons mb-2 d-inline">
                  <li style="">
                    <a
                      href="https://www.facebook.com/Eshopslk-2212428785713128/"
                      class="px-0 ml-0 mr-2"
                      ><i
                        class="fa fa-facebook-official f-sm-link"
                        style="
                          font-size: 34px;
                          color: #3b5998;
                          background-color: #fff;
                          width: 30px;
                          height: 30px;
                          border-radius: 4px;
                          text-align: center;
                          vertical-align: middle;
                        "
                      ></i
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/eshops.lk/"
                      class="px-0 mx-2"
                      ><i
                        class="fa fa-instagram f-sm-link"
                        style="
                          font-size: 30px;
                          color: #fff;
                          background: #d6249f;
                          background: radial-gradient(
                            circle at 30% 107%,
                            #fdf497 0%,
                            #fdf497 5%,
                            #fd5949 45%,
                            #d6249f 60%,
                            #285aeb 90%
                          );
                          width: 32px;
                          height: 32px;
                          border-radius: 4px;
                          text-align: center;
                          vertical-align: middle;
                        "
                      ></i
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"
                      class="px-0 mx-2"
                      ><i
                        class="fa fa-youtube-square f-sm-link"
                        style="
                          font-size: 35px;
                          color: #ff0000;
                          background-color: #fff;
                          width: 30px;
                          height: 30px;
                          border-radius: 6px;
                          text-align: center;
                          vertical-align: middle;
                        "
                      ></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Promotion -->
            <div class="col-sm col-md-8 col-lg-5">
              <!-- App promotion -->
              <div class="block-2 app-promotion">
                <a>
                  <!-- Icon -->
                  <img
                    src="../../static/img/icons/footer-android-chrome-90x90.png"
                    alt="mobile-icon"
                  />
                </a>
                <p class="m-f-text">
                  Tap the Add to Home Screen Tab in Chrome Browser on Android or
                  Safari Browser on IOS to Get the Splendid
                  <span style="color: #fd6a02; font-size: 20px"
                    >Mobile App</span
                  >
                  Directly
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Container End -->
      </footer>
      <!-- Footer Bottom -->
      <footer class="footer-bottom">
        <!-- Container Start -->
        <div class="container">
          <div class="row">
            <div class="col-12 mx-auto mt-5">
              <div class="copyright text-center">
                <img src="../../static/img/eshops-logo.png" alt="eshops-logo" />
                <p class="m-f-text mt-2">
                  © {{ new Date().getFullYear() }} eshops.lk | All Rights
                  Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Container End -->
        <!-- To Top -->
      </footer>
      <!-- <back-to-top bottom="50px" right="50px">
  <button type="button" class="btn btn-info btn-to-top"><i class="fa fa-chevron-up"></i></button>
</back-to-top> -->
    </div>
  </div>
</template>
<script>
import db from "../config/FirebaseInit";
import firebase from "firebase/app";
import cities from "../data/cities";
import categories from "../data/maincategories";
export default {
  name: "search",
  data() {
    return {
      cities: [
        {
          value: "Colombo",
          label: "Colombo",

          children: [
            {
              value: "Embilipitiya",
              label: "Embilipitiya",
            },
          ],
        },

        {
          value: "Kandy",
          label: "Kandy",

          children: [
            {
              value: "Katugastota",
              label: "Katugastota",
            },
            {
              value: "Awissawella",
              label: "Awissawella",
            },
          ],
        },
      ],

      categories: [
        {
          value: "Fashion",
          label: "Fashion",
        },

        {
          value: "Home Appliances",
          label: "Home Appliances",

          children: [
            {
              value: "Home Electronics",
              label: "Home Electronics",
            },
            {
              value: "Lighting & Electrical",
              label: "Lighting & Electrical",
            },
          ],
        },
        {
          value: "Clothing",
          label: "Clothing",

          children: [
            {
              value: "Fashion",
              label: "Fashion",
            },
          ],
        },
      ],
      city: [],
      cat: [],
      loading: false,
      loading1: true,
      fetch: false,
      noresults: false,
      shops: [],
      category: undefined,
      location: undefined,
      sortby: "",
      curprods: "",
      labelPosition: "left",
      links: [],
      isVisible: false,
      lastVisible: "",
      moreshops: undefined,
      user: false,
      visitor: false,
      admin: false,
      starterplanadmin: false,
      pageadmin: false,
      modalShow: false,
      modalShow0: false,
      modalShow1: false,
      modalShow2: false,
      datanotify: "Add to My SHOPiN",
      favshops: [],
      isFavShop: "show",
      fsfetched: false,
      param: "",
      place: "",
    };
  },
  watch: {
    $route(to, from) {
      //console.log('route change', this.$route.query.cat)
      this.noresults = false;
      this.shops = [];
      this.moreshops = undefined;
      this.loading = true;
      this.fetch = false;
      this.city = [];
      this.cat = [];
      this.category = this.$route.query.cat;
      this.location = this.$route.query.loc;

      if (this.$route.query.loc == "All of Colombo") {
        this.param = "district";
        this.place = "Colombo";
      } else if (this.$route.query.loc == "All of Kandy") {
        this.param = "district";
        this.place = "Kandy";
      } else if (this.$route.query.loc == "All of Gampaha") {
        this.param = "district";
        this.place = "Gampaha";
      } else if (this.$route.query.loc == "All of Kurunegala") {
        this.param = "district";
        this.place = "Kurunegala";
      } else if (this.$route.query.loc == "All of Kalutara") {
        this.param = "district";
        this.place = "Kalutara";
      } else if (this.$route.query.loc == "All of Ratnapura") {
        this.param = "district";
        this.place = "Ratnapura";
      } else if (this.$route.query.loc == "All of Galle") {
        this.param = "district";
        this.place = "Galle";
      } else if (this.$route.query.loc == "All of Anuradhapura") {
        this.param = "district";
        this.place = "Anuradhapura";
      } else if (this.$route.query.loc == "All of Kegalle") {
        this.param = "district";
        this.place = "Kegalle";
      } else if (this.$route.query.loc == "All of Badulla") {
        this.param = "district";
        this.place = "Badulla";
      } else if (this.$route.query.loc == "All of Matara") {
        this.param = "district";
        this.place = "Matara";
      } else if (this.$route.query.loc == "All of Puttalam") {
        this.param = "district";
        this.place = "Puttalam";
      } else if (this.$route.query.loc == "All of Ampara") {
        this.param = "district";
        this.place = "Ampara";
      } else if (this.$route.query.loc == "All of Hambantota") {
        this.param = "district";
        this.place = "Hambantota";
      } else if (this.$route.query.loc == "All of Jaffna") {
        this.param = "district";
        this.place = "Jaffna";
      } else if (this.$route.query.loc == "All of Batticaloa") {
        this.param = "district";
        this.place = "Batticaloa";
      } else if (this.$route.query.loc == "All of Matale") {
        this.param = "district";
        this.place = "Matale";
      } else if (this.$route.query.loc == "All of Monaragala") {
        this.param = "district";
        this.place = "Monaragala";
      } else if (this.$route.query.loc == "All of Polonnaruwa") {
        this.param = "district";
        this.place = "Polonnaruwa";
      } else if (this.$route.query.loc == "All of Trincomalee") {
        this.param = "district";
        this.place = "Trincomalee";
      } else if (this.$route.query.loc == "All of Vavuniya") {
        this.param = "district";
        this.place = "Vavuniya";
      } else if (this.$route.query.loc == "All of Mannar") {
        this.param = "district";
        this.place = "Mannar";
      } else if (this.$route.query.loc == "All of Mullativu") {
        this.param = "district";
        this.place = "Mullativu";
      } else if (this.$route.query.loc == "All of Nuwara Eliya") {
        this.param = "district";
        this.place = "Nuwara Eliya";
      } else if (this.$route.query.loc == "All of Kilinochchi") {
        this.param = "district";
        this.place = "Kilinochchi";
      } else if (this.$route.query.loc == "All of Sri Lanka") {
        this.param = "hasconfig";
        this.place = true;
      } else {
        this.param = "location";
        this.place = this.$route.query.loc;
      }
      this.$store.state.searchParam = this.param;
      this.$store.state.searchLocation = this.$route.query.loc;
      if (this.$route.fullPath != "/search") {
        //console.log('this. route change', this.$route.query.cat)
        // this.loading = true
        // this.fetch = false
        //console.log('this.loading', this.loading)

        if (!this.$store.state.searchResults[this.$route.query.cat]) {
          this.$store.state.searchResults[this.$route.query.cat] = {};
          // this.$store.state.searchResults[this.param][this.place]['results']
        }
        if (
          !this.$store.state.searchResults[this.$route.query.cat][
            this.$route.query.loc
          ]
        ) {
          this.$store.state.searchResults[this.$route.query.cat][
            this.$route.query.loc
          ] = {};
          // this.$store.state.searchResults[this.param][this.place]['results']
        }
        if (
          this.$store.state.searchResults[this.$route.query.cat][
            this.$route.query.loc
          ]["results"] != undefined
        ) {
          this.shops =
            this.$store.state.searchResults[this.$route.query.cat][
              this.$route.query.loc
            ]["results"];
          this.lastVisible =
            this.$store.state.searchResults[this.$route.query.cat][
              this.$route.query.loc
            ]["lastVisible"];
          if (this.shops.length >= 20) {
            this.moreshops = "show";
          }
          this.loading = false;
          this.fetch = true;
          //console.log('results from store')
        } else {
          db.collection("shops")
            .where("cat", "==", this.$route.query.cat)
            .where(this.param, "==", this.place)
            .where("permission", "==", "allowed")
            .where("search", "==", "yes")
            .orderBy("rank")
            .orderBy("visits", "desc")
            .limit(20)
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                const data = {
                  id: doc.id,
                  name: doc.data().name,
                  shoptype: doc.data().shoptype,
                  location: doc.data().location,
                  owner: doc.data().owner,
                  visits: doc.data().visits,
                  homeimg: doc.data().homeimg,
                  plan: doc.data().plan,
                  details: doc.data().details,
                  isfavshop: false,
                  isHosted: doc.data().isHosted,
                  domain: doc.data().domain,
                  isCloned: doc.data().isCloned,
                  realOwner: doc.data().realOwner,
                  regtel: doc.data().regtel,
                };
                if (doc.data().homeimg != undefined) {
                  data.homeimg = doc.data().homeimg;
                } else {
                  data.homeimg = "../../static/images/ecommerce.jpg";
                }
                this.shops.push(data);
                //console.log(this.shops)
              });
              var findFavShop = function (fshops, id) {
                var findedid = fshops.find((fs, index) => {
                  return fs == id;
                });
                return findedid;
              };
              if (firebase.auth().currentUser) {
                this.shops.forEach((shop) => {
                  var isFavShop = findFavShop(
                    this.favshops[0].favshops,
                    shop.id
                  );
                  //console.log('isFavShop',this.isFavShop)
                  if (isFavShop == shop.id) {
                    shop.isfavshop = true;
                  }
                });
              }
              this.loading = false;
              this.fetch = true;
              if (querySnapshot.docs.length == 0) {
                this.noresults = true;
                this.lastVisible = undefined;
                //console.log("noresults", this.noresults);
              }
              if (querySnapshot.docs.length > 0) {
                this.noresults = false;
                this.lastVisible =
                  querySnapshot.docs[querySnapshot.docs.length - 1];
                this.$store.state.searchResults[this.$route.query.cat][
                  this.$route.query.loc
                ]["results"] = this.shops;
                this.$store.state.searchResults[this.$route.query.cat][
                  this.$route.query.loc
                ]["lastVisible"] = this.lastVisible;
                //console.log("noresults", this.noresults);
              }

              //console.log(" moreitems last", this.lastVisible);
              //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
              if (querySnapshot.docs.length == 20) {
                this.moreshops = "show";
                //console.log("last", this.moreshops);
              }
            });
        }
      } else if (this.$route.fullPath == "/search") {
        this.cat = undefined;
        this.city = undefined;
        this.fetch = true;
        this.loading = false;
        //console.log("this.fetch", this.fetch);
      } else {
        this.category = undefined;
        this.location = undefined;
        this.fetch = true;
        this.loading = false;
        //console.log("this.fetch", this.fetch);
      }
    },
  },
  methods: {
    selectCat(value) {
      //console.log(value)
      if (value.length == 1) {
        this.category = value[0];
        //console.log('this.searchForm.category',this.category)
      } else if (value.length == 2) {
        this.category = value[1];
        //console.log('this.searchForm.category',this.category)
      } else if (value.length == 0) {
        this.category = undefined;
      }
    },
    handleChange(value) {
      //console.log(value)
      if (value.length == 1) {
        this.location = value[0];
      } else if (value.length == 2) {
        this.location = value[1];
      }
      //console.log('this.searchForm.location',this.location)
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("/");
        });
    },
    showme() {
      if (this.category == undefined || this.location == undefined) {
        this.modalShow = true;
      } else {
        this.$router.push({
          name: "search",
          query: { cat: this.category, loc: this.location },
        });
      }
    },
    // resetLoc(){
    //   //console.log("set loc");
    //   this.location = ''
    // },
    setRoute() {
      //console.log("setRoute");
      this.$route.query.cat = this.category;
      this.$route.query.loc = this.location;
      if (
        this.$route.query.cat == undefined ||
        this.$route.query.loc == undefined
      ) {
        this.modalShow = true;
        this.noresults = false;
      } else if (
        this.$route.query.cat != undefined &&
        this.$route.query.loc != undefined
      ) {
        //console.log("setRoute if true", this.$route.query)
        //console.log('route change', this.$route.query.cat)
        this.noresults = false;
        this.shops = [];
        this.lastVisible = undefined;
        db.collection("shops")
          .where("cat", "==", this.$route.query.cat)
          .where("location", "==", this.$route.query.loc)
          .where("permission", "==", "allowed")
          .where("search", "==", "yes")
          .orderBy("rank")
          .orderBy("visits", "desc")
          .limit(20)
          .onSnapshot((querySnapshot) => {
            this.shops = [];
            querySnapshot.forEach((doc) => {
              const data = {
                id: doc.id,
                name: doc.data().name,
                shoptype: doc.data().shoptype,
                location: doc.data().location,
                owner: doc.data().owner,
                visits: doc.data().visits,
                homeimg: doc.data().homeimg,
                plan: doc.data().plan,
                details: doc.data().details,
              };
              this.shops.push(data);
              //console.log(this.shops)
              this.loading = false;
              this.fetch = true;
            });
            if (querySnapshot.docs.length == 0) {
              this.noresults = true;
              this.lastVisible = undefined;
              //console.log("noresults", this.noresults);
            }
            this.lastVisible =
              querySnapshot.docs[querySnapshot.docs.length - 1];
            //console.log(" moreitems last", this.lastVisible);
            //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
            if (querySnapshot.docs.length < 20) {
              this.lastVisible = undefined;
              //console.log("last", this.lastVisible);
            }
          });
      }
    },
    userVisits(n) {
      if (firebase.auth().currentUser) {
        if (
          firebase.auth().currentUser.displayName == "shop owner" ||
          firebase.auth().currentUser.displayName == "starterplan shop owner"
        ) {
          var newVisits = this.shops[n].visits;
        }
        if (
          firebase.auth().currentUser.displayName == "page owner" ||
          firebase.auth().currentUser.displayName == null
        ) {
          var newVisits = this.shops[n].visits + 1;
          //console.log('newvists', newVisits)
          db.collection("shops")
            .doc(this.shops[n].id)
            .update({
              visits: newVisits,
            })
            .then(() => {
              //console.log('newvists', newVisits)
            })
            .catch((error) => {
              //console.log('error',error)
            });
        }
      } else {
        // var newVisits = this.shops[n].visits + 1
        // //console.log('newvists', newVisits)
        //  db.collection('shops').doc(this.shops[n].id)
        // .update({
        //   visits: newVisits
        // })
        // .then(() => //console.log('newvists', newVisits))
        // .catch(error => //console.log('error',error))
      }
    },

    addToFavourite(shop) {
      if (!firebase.auth().currentUser) {
        this.modalShow0 = true;
      }
      if (firebase.auth().currentUser) {
        // if(firebase.auth().currentUser.displayName == 'shop owner'){
        // 	this.modalShow = true
        // }else{
        if (this.favshops[0].favshops.length <= 25) {
          this.favshops[0].favshops.push(shop.id);
          //console.log('favsp updated', this.favshops[0].favshops)
          shop.isfavshop = true;
          this.modalShow2 = true;
          db.collection("users")
            .doc(this.favshops[0].docid)
            .update({
              favshops: this.favshops[0].favshops,
            })
            .then(() => {
              //console.log('')
            })
            .catch((error) => {
              //console.log('error',error)
            });
        } else {
          this.modalShow1 = true;
        }
        //}
      }
      // else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){
      // 	this.modalShow0 = true
      // }
    },

    submitForm(formName) {},

    querySearch(queryString, cb) {
      var links = this.links;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return (link) => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      //console.log('item is',item)
      //console.log(this.location)
      //console.log(this.category)
    },

    //  initToTopButton: function() {
    //   $(document).bind('scroll', function() {
    //     var backToTopButton = $('.goTop');
    //     if ($(document).scrollTop() > 250) {
    //       backToTopButton.addClass('isVisible');
    //       this.isVisible = true;
    //     } else {
    //       backToTopButton.removeClass('isVisible');
    //       this.isVisible = false;
    //     }
    //   }.bind(this));
    // },
    // backToTop: function() {
    //   $('html,body').stop().animate({
    //     scrollTop: 0
    //   }, 'slow', 'swing');
    // },

    moreItems() {
      if (this.lastVisible != undefined) {
        this.loading1 = false;
        //this.fetch = false
        db.collection("shops")
          .where("cat", "==", this.$route.query.cat)
          .where(this.param, "==", this.place)
          .where("permission", "==", "allowed")
          .where("search", "==", "yes")
          .orderBy("rank")
          .orderBy("visits", "desc")
          .startAfter(this.lastVisible)
          .limit(20)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = {
                id: doc.id,
                name: doc.data().name,
                shoptype: doc.data().shoptype,
                location: doc.data().location,
                owner: doc.data().owner,
                visits: doc.data().visits,
                homeimg: doc.data().homeimg,
                plan: doc.data().plan,
                details: doc.data().details,
                isfavshop: false,
                isHosted: doc.data().isHosted,
                domain: doc.data().domain,
                isCloned: doc.data().isCloned,
                realOwner: doc.data().realOwner,
                regtel: doc.data().regtel,
              };
              if (doc.data().homeimg != undefined) {
                data.homeimg = doc.data().homeimg;
              } else {
                data.homeimg = "../../static/images/ecommerce.jpg";
              }
              this.shops.push(data);
              //console.log(this.shops)
            });
            var findFavShop = function (fshops, id) {
              var findedid = fshops.find((fs, index) => {
                return fs == id;
              });
              return findedid;
            };
            if (firebase.auth().currentUser) {
              this.shops.forEach((shop) => {
                var isFavShop = findFavShop(this.favshops[0].favshops, shop.id);
                //console.log('isFavShop',this.isFavShop)
                if (isFavShop == shop.id) {
                  shop.isfavshop = true;
                }
              });
            }
            this.loading1 = true;
            //this.fetch = true
            if (querySnapshot.docs.length > 0) {
              this.lastVisible =
                querySnapshot.docs[querySnapshot.docs.length - 1];
              this.$store.state.searchResults[this.$route.query.cat][
                this.$route.query.loc
              ]["lastVisible"] = this.lastVisible;
              //console.log("noresults", this.lastVisible);
            }
            //console.log(" moreitems last", this.lastVisible);
            //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
            if (querySnapshot.docs.length < 20) {
              this.moreshops = undefined;
              //console.log("last", this.moreshops);
            }
          });
      }
    },
  },
  beforeCreate() {
    if (firebase.auth().currentUser) {
      db.collection("users")
        .where("uid", "==", firebase.auth().currentUser.uid)
        .onSnapshot((querySnapshot) => {
          this.favshops = [];
          querySnapshot.forEach((doc) => {
            const data = {
              favshops: doc.data().favshops,
              docid: doc.id,
            };
            this.favshops.push(data);
            this.fsfetched = true;
            //console.log('favshops',this.favshops)
          });
        });
    }
  },
  created() {
    this.cities = cities;
    this.categories = categories;
    if (firebase.auth().currentUser) {
      if (firebase.auth().currentUser.displayName == null) {
        this.user = true;
      } else if (
        firebase.auth().currentUser.displayName == "shop owner" ||
        firebase.auth().currentUser.displayName == "starterplan shop owner"
      ) {
        this.admin = true;
      } else if (firebase.auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      }
    } else {
      this.visitor = true;
    }

    this.$nextTick(function () {
      //this.initToTopButton();
    });
    // this.backToTop()
    //console.log('this.route', this.$route)
    //console.log('this.loading', this.loading)
    // this.cat[0] = this.$route.query.cat
    // this.city[0] = this.$route.query.
    this.category = this.$route.query.cat;
    this.location = this.$route.query.loc;

    if (this.$route.fullPath != "/search") {
      //console.log('this.loading', this.$route.query.cat)
      if (this.$route.query.loc == "All of Colombo") {
        this.param = "district";
        this.place = "Colombo";
      } else if (this.$route.query.loc == "All of Kandy") {
        this.param = "district";
        this.place = "Kandy";
      } else if (this.$route.query.loc == "All of Gampaha") {
        this.param = "district";
        this.place = "Gampaha";
      } else if (this.$route.query.loc == "All of Kurunegala") {
        this.param = "district";
        this.place = "Kurunegala";
      } else if (this.$route.query.loc == "All of Kalutara") {
        this.param = "district";
        this.place = "Kalutara";
      } else if (this.$route.query.loc == "All of Ratnapura") {
        this.param = "district";
        this.place = "Ratnapura";
      } else if (this.$route.query.loc == "All of Galle") {
        this.param = "district";
        this.place = "Galle";
      } else if (this.$route.query.loc == "All of Anuradhapura") {
        this.param = "district";
        this.place = "Anuradhapura";
      } else if (this.$route.query.loc == "All of Kegalle") {
        this.param = "district";
        this.place = "Kegalle";
      } else if (this.$route.query.loc == "All of Badulla") {
        this.param = "district";
        this.place = "Badulla";
      } else if (this.$route.query.loc == "All of Matara") {
        this.param = "district";
        this.place = "Matara";
      } else if (this.$route.query.loc == "All of Puttalam") {
        this.param = "district";
        this.place = "Puttalam";
      } else if (this.$route.query.loc == "All of Ampara") {
        this.param = "district";
        this.place = "Ampara";
      } else if (this.$route.query.loc == "All of Hambantota") {
        this.param = "district";
        this.place = "Hambantota";
      } else if (this.$route.query.loc == "All of Jaffna") {
        this.param = "district";
        this.place = "Jaffna";
      } else if (this.$route.query.loc == "All of Batticaloa") {
        this.param = "district";
        this.place = "Batticaloa";
      } else if (this.$route.query.loc == "All of Matale") {
        this.param = "district";
        this.place = "Matale";
      } else if (this.$route.query.loc == "All of Monaragala") {
        this.param = "district";
        this.place = "Monaragala";
      } else if (this.$route.query.loc == "All of Polonnaruwa") {
        this.param = "district";
        this.place = "Polonnaruwa";
      } else if (this.$route.query.loc == "All of Trincomalee") {
        this.param = "district";
        this.place = "Trincomalee";
      } else if (this.$route.query.loc == "All of Vavuniya") {
        this.param = "district";
        this.place = "Vavuniya";
      } else if (this.$route.query.loc == "All of Mannar") {
        this.param = "district";
        this.place = "Mannar";
      } else if (this.$route.query.loc == "All of Mullativu") {
        this.param = "district";
        this.place = "Mullativu";
      } else if (this.$route.query.loc == "All of Nuwara Eliya") {
        this.param = "district";
        this.place = "Nuwara Eliya";
      } else if (this.$route.query.loc == "All of Kilinochchi") {
        this.param = "district";
        this.place = "Kilinochchi";
      } else if (this.$route.query.loc == "All of Sri Lanka") {
        this.param = "hasconfig";
        this.place = true;
      } else {
        this.param = "location";
        this.place = this.$route.query.loc;
      }

      if (this.$route.query.cat == "Vehicles") {
        this.curprods = 5;
      } else {
        this.curprods = 25;
      }
      this.loading = true;
      this.fetch = false;
      this.$store.state.searchParam = this.param;
      this.$store.state.searchLocation = this.$route.query.loc;
      //console.log('this.loading', this.loading)
      if (!this.$store.state.searchResults[this.$route.query.cat]) {
        this.$store.state.searchResults[this.$route.query.cat] = {};
        // this.$store.state.searchResults[this.param][this.place]['results']
      }
      if (
        !this.$store.state.searchResults[this.$route.query.cat][
          this.$route.query.loc
        ]
      ) {
        this.$store.state.searchResults[this.$route.query.cat][
          this.$route.query.loc
        ] = {};
        // this.$store.state.searchResults[this.param][this.place]['results']
      }
      if (
        this.$store.state.searchResults[this.$route.query.cat][
          this.$route.query.loc
        ]["results"] != undefined
      ) {
        this.shops =
          this.$store.state.searchResults[this.$route.query.cat][
            this.$route.query.loc
          ]["results"];
        this.lastVisible =
          this.$store.state.searchResults[this.$route.query.cat][
            this.$route.query.loc
          ]["lastVisible"];
        if (this.shops.length >= 20) {
          this.moreshops = "show";
        }
        this.loading = false;
        this.fetch = true;
        //console.log('results from store')
      } else {
        db.collection("shops")
          .where("cat", "==", this.$route.query.cat)
          .where(this.param, "==", this.place)
          .where("permission", "==", "allowed")
          .where("search", "==", "yes")
          .orderBy("rank")
          .orderBy("visits", "desc")
          .limit(20)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = {
                id: doc.id,
                name: doc.data().name,
                shoptype: doc.data().shoptype,
                location: doc.data().location,
                owner: doc.data().owner,
                visits: doc.data().visits,
                homeimg: doc.data().homeimg,
                plan: doc.data().plan,
                details: doc.data().details,
                isfavshop: false,
                isHosted: doc.data().isHosted,
                domain: doc.data().domain,
                isCloned: doc.data().isCloned,
                realOwner: doc.data().realOwner,
                regtel: doc.data().regtel,
              };
              if (doc.data().homeimg != undefined) {
                data.homeimg = doc.data().homeimg;
              } else {
                data.homeimg = "../../static/images/ecommerce.jpg";
              }
              this.shops.push(data);
              //console.log(this.shops)
              var findFavShop = function (fshops, id) {
                var findedid = fshops.find((fs, index) => {
                  return fs == id;
                });
                return findedid;
              };
              if (firebase.auth().currentUser && this.fsfetched) {
                this.shops.forEach((shop) => {
                  var isFavShop = findFavShop(
                    this.favshops[0].favshops,
                    shop.id
                  );
                  //console.log('isFavShop',this.isFavShop)
                  if (isFavShop == shop.id) {
                    shop.isfavshop = true;
                  }
                });
              }
            });

            this.loading = false;
            this.fetch = true;
            //console.log('fetched from created')
            if (querySnapshot.docs.length == 0) {
              this.noresults = true;
              this.lastVisible = undefined;
              //console.log("noresults", this.noresults);
            }
            if (querySnapshot.docs.length > 0) {
              this.noresults = false;
              this.lastVisible =
                querySnapshot.docs[querySnapshot.docs.length - 1];
              this.$store.state.searchResults[this.$route.query.cat][
                this.$route.query.loc
              ]["results"] = this.shops;
              this.$store.state.searchResults[this.$route.query.cat][
                this.$route.query.loc
              ]["lastVisible"] = this.lastVisible;
              //console.log("noresults", this.noresults);
            }

            //console.log(" moreitems last", this.lastVisible);
            //console.log(" moreitems snapshot.length", querySnapshot.docs.length);
            if (querySnapshot.docs.length == 20) {
              this.moreshops = "show";
              //console.log("last", this.moreshops);
            }
          });
      }
    } else if (this.$route.fullPath == "/search") {
      this.fetch = true;
      this.loading = false;
      //console.log("this.fetch", this.fetch);
    } else {
      this.fetch = true;
      this.loading = false;
      //console.log("this.fetch", this.fetch);
    }
  },
  mounted() {
    // this.links = towns;
  },
};
</script>
<style scoped>
@import url("~@/assets/main/css/styles.css");
@import url("~@/assets/main/css/nav.css");
@import url("~@/assets/main/css/button.css");
@import url("~@/assets/main/css/loading.css");
/* @import url('~@/assets/admin/css/admin-loader.css'); */

.block2-pic {
  position: relative;
}
.hov-img0 {
  display: block;
  overflow: hidden;
}

.hov-img0 img {
  width: 100%;
  -webkit-transition: transform 0.9s ease;
  -o-transition: transform 0.9s ease;
  -moz-transition: transform 0.9s ease;
  transition: transform 0.9s ease;
}

.hov-img0:hover img {
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -ms-transform: scale(1.1);
  -o-transform: scale(1.1);
  transform: scale(1.1);
}

.goTop {
  cursor: pointer;
  border-radius: 5px;
  background-color: rgb(1, 14, 27);
  background-color: rgba(1, 14, 27, 0.7);
  position: fixed;
  width: 45px;
  height: 45px;
  display: block;
  right: 15px;
  bottom: 15px;
  border: none;
  opacity: 0;
  z-index: -1;
}

.product-meta li a i {
  color: #7c7ada;
  font-size: 14px;
}
.product-meta li a {
  color: #4a4aec;
}
.product-meta li a :hover {
  color: #7c7ada;
}
.fa {
  color: #7c7ada;
  font-size: 15px;
}

.isVisible {
  opacity: 0.8;
  z-index: 4;
  transition: all 0.4s ease-in;
}

.flex-c-m {
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
}
.flex-w {
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}
.w-full {
  width: 100%;
}
.bg2 {
  background-color: #717fe0;
}

.size-103 {
  min-width: 129px;
  height: 46px;
  cursor: pointer;
}
.cl5 {
  color: #fff;
}
.stext-101 {
  font-size: 15px;
  line-height: 1.466667;
  text-transform: uppercase;
}
.form-item {
  width: 200px;
  margin-bottom: 0px;
  margin-right: 0px;
}
.m-nav {
  display: none;
}
.bg-dark {
  color: #180000 !important;
  background-color: #180000 !important;
}
.f-sm-link {
  text-decoration: none;
}
@media (max-width: 767px) {
  .m-size {
    font-size: 16px;
  }
  .form-item {
    width: 150px;
  }
  .d-nav {
    display: none;
  }
  .m-nav {
    display: block;
  }
  .bg-dark {
    color: #180000 !important;
    background-color: #180000 !important;
  }
  .navbar-brand {
    display: inline-block;
    padding-top: 0rem;
    padding-bottom: 0rem;
    margin-right: 1rem;
    line-height: inherit;
    white-space: nowrap;
  }
  .navbar-toggler {
    padding: 0rem;

    line-height: 1;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 0rem;
  }
  .m-link {
    font-size: 15px;
  }
}
@media (max-width: 575px) {
  .form-item1 {
    width: 310px !important;
    margin: auto !important;
  }

  .form-item2 {
    width: 150px !important;
    display: inline-flex !important;
  }

  .form-item3 {
    width: 150px !important;
    margin: 10px 80px 0 80px !important;
  }

  .el-form {
    width: 310px;
  }
  .m-size {
    font-size: 14px;
  }
  .category-search-filter {
    padding-bottom: 8px;
    margin-bottom: 25px;
  }
  .search-result {
    margin-top: 12px;
  }
  .m-link {
    font-size: 14px;
  }
  .m-f-text {
    font-size: 12px;
  }
  .footer .block ul li a {
    font-size: 12px;
  }
}
@media (max-width: 320px) {
  .form-item1 {
    width: 300px !important;
    margin: auto !important;
  }

  .form-item2 {
    width: 135px !important;
    display: inline-flex !important;
  }

  .form-item3 {
    width: 150px !important;
    margin: 10px 65px 0 75px !important;
  }

  .el-form {
    width: 300px;
  }
}
.tooltip100 {
  position: relative;
}

.tooltip100::after {
  content: attr(data-tooltip);
  font-family: Poppins-Regular;
  font-size: 14px;
  color: #fff;
  line-height: 18px;
  white-space: nowrap;

  display: block;
  position: absolute;
  background: #180000;
  border: 1px solid #180000;
  height: 20px;
  padding: 0px 8px;
  top: -35px;
  left: 0%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);

  box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.18);
  -moz-box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.18);
  -webkit-box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.18);
  -o-box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.18);
  -ms-box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.18);

  -webkit-transition: all 0.2s;
  -o-transition: all 0.2s;
  -moz-transition: all 0.2s;
  transition: all 0.2s;

  visibility: hidden;
  opacity: 0;
}

.tooltip100:hover:after {
  visibility: visible;
  opacity: 1;
}

.anim {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100%;
  height: 100vh;
  background-color: #0e0d0d9c;
}
.spinner {
  margin: 45vh auto;
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;

  -webkit-animation: sk-rotate 2s infinite linear;
  animation: sk-rotate 2s infinite linear;
}

.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: rgb(252, 249, 249);
  border-radius: 100%;

  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes sk-rotate {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue